
import React from "react";

// reactstrap components
import { Container, Nav, NavItem, NavLink } from "reactstrap";

function Footer() {
  return (
    <>
      <footer className="footer">
        <Container fluid>
          <Nav>
            <NavItem>
              <NavLink href="https://www.sedeschuquisaca.gob.bo">
                SEDES CHUQUISACA
              </NavLink>
            </NavItem>

          </Nav>
          <div className="copyright">
            © PROG. Chagas Chuquisaca{" "}
            <i className="tim-icons icon-heart-2" /> {"  "}
            <a
              href="https://www.etv.sedeschuquisaca.gob.bo"
              target="_blank"
              style={{ color: 'blue', fontWeight: 'bold' }}
            >
              Sitio web 2024
            </a>{" "}
          </div>
        </Container><br />

        <div className="text-center">
         Desarrollador {" "}
          <a
            href="https://www.linkedin.com/in/gustavo-aguilar-torres-56a3a121a/"
            target="_blank"
            style={{ color: 'blue', fontWeight: 'bold' }}

          >
            Ing. Gustavo Aguilar T.
          </a>
        </div>
      </footer>


    </>
  );
}

export default Footer;
